import React from 'react';

function SpeakerIcon({ width = 8, height = 12, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 8 12">
      <g>
        <path d="M7.83585879,0.0324633119 C7.73544107,-0.0199299502 7.61487427,-0.00806092645 7.52575969,0.0619663139 L3.09083463,3.52585613 L0.595134737,3.52585613 C0.267343763,3.52585613 0,3.80223483 0,4.14236714 L0,7.85838893 C0,8.19784301 0.267343763,8.47439126 0.595134737,8.47439126 L3.09083463,8.47439126 L7.52575969,11.9381115 C7.5778524,11.9791444 7.64092063,12 7.70366123,12 C7.7490376,12 7.79392252,11.9893179 7.83585879,11.9676145 C7.9361127,11.9158995 8,11.8094174 8,11.6934401 L8,0.306468204 C8,0.190490886 7.9361127,0.0841783442 7.83585879,0.0324633119" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default SpeakerIcon;
